import React from "react"

/**
 * The sidenav lets users navigate through subsets of data pertaining to a resource.
 * It can be nested under the page header navigation, as secondary navigation.
 *
 * The expected structure of a `Sidenav` is:
 * `<Sidenav> <SidenavSection> <SidenavItem /> </SidenavSection> </Sidenav>`
 *
 * Please refer to each component's documentation for more information on how to use them.
 */
export function Sidenav({
  children,
  label,
  selectedItemLabel,
  className,
  popoverId,
}: {
  /**
   * Default slot used to nest `SidenavSection` components.
   */
  children: React.ReactNode
  className?: string
  /**
   * Label for the sidenav, used for accessibility.
   */
  label?: string
  /**
   * The id of the popover container.
   */
  popoverId?: string
  /**
   * Label displayed in the responsive header of the sidenav.
   */
  selectedItemLabel?: string
}) {
  const popoverIdProp =
    popoverId && popoverId.trim() ? { "popover-id": popoverId } : {}

  return (
    <tds-sidenav
      label={label}
      selected-item-label={selectedItemLabel}
      class={className}
      {...popoverIdProp}
    >
      {children}
    </tds-sidenav>
  )
}
